export const language = "it";
export const properLanguage = language

export const OFFERS_URL = "/noleggio-barche";
export const WISHLIST_URL = "/lista-desideri";
export const DESTINATIONS_URL = "/destinazioni";
export const FAQ_URL = "/domande-frequenti";
export const CONTACT_URL = "/contatto";
export const PARTNERS_URL = "/partner";
export const INSURANCE_URL = "/assicurazione";

export const DEFAULT_COUNTRY = 100147;
